//ajout de dark mode

import React, { useEffect, useState } from "react";
import "./darkMode.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";

const DarkMode = ({ onThemeChange }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    const localTheme = window.localStorage.getItem("theme");
    return localTheme || "light";
  });

  const toggleTheme = () => {
    const newTheme = currentTheme === "light" ? "dark" : "light";
    window.localStorage.setItem("theme", newTheme);
    setCurrentTheme(newTheme);
    onThemeChange(newTheme);
  };

  useEffect(() => {
    if (currentTheme === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [currentTheme]);

  return (
    <div className={`dark-mode ${currentTheme}`}>
      <button onClick={toggleTheme}>
        {currentTheme === "light" ? (
          <FontAwesomeIcon icon={faMoon} />
        ) : (
          <FontAwesomeIcon icon={faSun} />
        )}
      </button>
    </div>
  );
};

export default DarkMode;
